import { render, staticRenderFns } from "./NewsView.vue?vue&type=template&id=9dff9fd8"
import script from "./NewsView.vue?vue&type=script&lang=js"
export * from "./NewsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports